/**
 * Employer Zendesk snippet key from env. react-zendesk builds
 * `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}` — if `zendeskKey` is
 * undefined, the URL becomes `...key=undefined` and the snippet throws (E2E pageErrors).
 */
export default function getEmployerZendeskSnippetKey() {
  const raw = process.env.REACT_APP_EMPLOYER_ZENDESK_KEY;
  if (raw == null) {
    return '';
  }
  if (typeof raw !== 'string') {
    return '';
  }
  const t = raw.trim();
  if (!t || t === 'undefined' || t === 'null' || t === '""' || t === "''") {
    return '';
  }
  // Real snippet keys are long alphanumerics; block placeholders and accidental short values.
  if (t.length < 16) {
    return '';
  }
  return t;
}
